import type { WidgetProps } from '@wix/yoshi-flow-editor';
import loadable from '@wix/yoshi-flow-editor/loadable';
import type { FC } from 'react';
import React from 'react';

import type { ControllerProps } from '../../../types';

const Widget = loadable(() => {
  return import(/* webpackChunkName: "RootWidget" */ './Widget');
});

const Root: FC<WidgetProps<ControllerProps | undefined>> = (
  controllerProps,
) => {
  if (!controllerProps.isRendered) {
    return null;
  }

  return <Widget {...controllerProps} />;
};

export default Root;
